module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Персональные данные")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.deleteLocalPersonalData
    }
  }, [_vm._v("Очистить")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left shedule-header"
  }, [_c('h3', {
    staticClass: "shedule-title"
  }, [_vm._v("Очистка локальной копии персональных данных")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ded98c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/PersonalData.vue
// module id = 919
// module chunks = 0